export * from './tenant-list-config';
export * from './tenant-create-form-config';
export * from './tenant-edit-form-config';
